import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ROUTES } from "../../routes";

export const AdminRoutes = () => {
  const { currentUser } = useAuth();
  return <>{currentUser?.isAdmin() ? <Outlet /> : <Navigate to={ROUTES.LOGIN} />}</>;
};
